import React from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  FormHelperText
} from '@material-ui/core'
import i18n from 'i18next'
import { isEmpty } from 'lodash/lang'
import { find } from 'lodash/collection'

import AddAddressInvoiceForm from './AddAddressInvoiceForm'
import styles from './styles'

type FormField = {
  value: string,
  isRequired?: boolean,
  error?: boolean,
  isValid?: Function
}

type State = {
  wantsInvoice: boolean,
  formFields: {
    address: FormField
  }
}

type Props = {
  addressID: number,
  addresses: Object,
  setInvoiceAddressID: Function,
  navigateTo: Function,
  updateInvoiceData: Function
}

class AddressInvoicePicker extends React.Component<Props, State> {
  state = {
    wantsInvoice: Boolean(this.props.comesFromEditingAddress),
    formFields: {
      address: {
        value: this.props.comesFromEditingAddress
          ? this.props.comesFromEditingAddress
          : this.props.addressID,
        error: false,
        isRequired: true,
        isValid: (address: string) => !isEmpty(address)
      }
    }
  }

  onInvoiceChange: Function = () => {
    this.props.setInvoiceAddressID(
      this.state.wantsInvoice ? null : this.state.formFields.address.value
    )
    this.setState({
      ...this.state,
      wantsInvoice: !this.state.wantsInvoice
    })
  }

  onInputChange: Function = (event: Object) => {
    this.setState({
      ...this.state,
      formFields: {
        ...this.state.formFields,
        [event.target.name]: {
          ...this.state.formFields[event.target.name],
          value: event.target.value
        }
      }
    })
    this.props.setInvoiceAddressID(event.target.value)
  }

  render () {
    return (
      <Grid container>
        {this.state.wantsInvoice && (
          <Grid item xs={12} style={styles.selectorWrapper}>
            <FormControl
              fullWidth
              margin='none'
              required={this.state.formFields.address.isRequired}
              variant='outlined'
              error={this.state.formFields.address.error}
              disabled={this.props.isDisabled}
            >
              <InputLabel htmlFor='delivery-address'>
                {i18n.t('checkout.selectDeliveryAddressInput')}
              </InputLabel>
              <Select
                value={this.state.formFields.address.value}
                onChange={this.onInputChange}
                input={
                  <OutlinedInput
                    labelWidth={260}
                    name='address'
                    id='invoice-address'
                  />
                }
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
                }}
              >
                {this.props.addresses.map((address, idx) => (
                  <MenuItem value={address.id} key={idx}>
                    {address.alias}
                  </MenuItem>
                ))}
              </Select>
              {this.state.formFields.address.error && (
                <FormHelperText error>
                  {i18n.t('checkout.error.addressSelect')}
                </FormHelperText>
              )}
            </FormControl>
            <AddAddressInvoiceForm
              hasInvoice={
                find(this.props.addresses, [
                  'id',
                  this.state.formFields.address.value
                ]).hasInvoice
              }
              address={find(this.props.addresses, [
                'id',
                this.state.formFields.address.value
              ])}
              navigateTo={this.props.navigateTo}
              updateInvoiceData={this.props.updateInvoiceData}
            />
          </Grid>
        )}
      </Grid>
    )
  }
}

export default AddressInvoicePicker
